import angular from 'angular';
import duplicateContactsModal from './duplicateContactsModal';

export default angular
  .module('mergeContact.scene.duplicateContacts.components', [])
  .component('duplicateContactsModal', duplicateContactsModal).name;
